var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 17,
    viewBox: "0 0 28 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17798",
    "data-name": "Group 17798",
    transform: "translate(-367.5 -28.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_151",
    "data-name": "Line 151",
    x1: 13,
    transform: "translate(381 30)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_152",
    "data-name": "Line 152",
    x1: 25,
    transform: "translate(369 37)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    x1: 19,
    transform: "translate(375 44)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenu);
export default __webpack_public_path__ + "static/media/mobile_menu.94a19741ab84e4a24413a34bd55d0928.svg";
export { ForwardRef as ReactComponent };